import { useMutation } from 'react-query';
import { sendEmailVerification } from '../../../state/context/AuthContext';

export default function useSendVerifyEmail() {
  return useMutation( () => sendEmailVerification());
}
